import React from 'react'
import { Modal } from 'react-bootstrap'

export default function ElectricHandModalGrommet({
  pageLanguage ,
  modals,
  modalHandleClose,
  t
}) {
  return (
   <Modal
   dialogClassName={`noPower_modal mediumSizeModal ${
     pageLanguage === "fa" ? "font_farsi" : "font_en"
   }`}
   show={modals["noPower"] === undefined ? false : modals["noPower"]}
   onHide={() => modalHandleClose("noPower")}
 >
   <Modal.Header closeButton></Modal.Header>
   <Modal.Body>
     <p>{t("modal_no power")}</p>

     <br />
     <div className=" text_center">
       <button className=" btn btn-new-dark" onClick={() => modalHandleClose("noPower")}>
         {t("CONTINUE")}
       </button>
     </div>
   </Modal.Body>
 </Modal>
  )
}
